import React, { useCallback, useState } from 'react';
import Button from 'src/@vymo/ui/atoms/button';
import { CardGrid } from 'src/@vymo/ui/blocks';
import SkeletonLoader from 'src/@vymo/ui/blocks/skelton';
import Widget from 'src/@vymo/ui/molecules/widget';
import { Keys, locale } from 'src/i18n';
import { PERFORMANCE_DASHBOARD } from 'src/modules/constants';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { renderModule } from 'src/workspace/slice';
import { isLmsWeb, navigate } from 'src/workspace/utils';
import EmptyState from '../components/emptyState';
import ErrorState from '../components/errorState';
import { getPerformanceSnapshot, getStatus } from '../selector';
import PerformanceSnapshotCard from './PerformanceSnapshotCard';
import styles from './index.module.scss';

function PerformanceSnapshot() {
  const performanceSnapshotData = useAppSelector(getPerformanceSnapshot);
  const dispatch = useAppDispatch();
  const [, setNoDataCards] = useState<string[]>([]);
  const status = useAppSelector((state) =>
    getStatus(state, 'performance_snapshot'),
  );

  const adjustNumberOfCards = useCallback((type: string) => {
    setNoDataCards((prevNoDataCards = []) => {
      const alreadyExists = prevNoDataCards.findIndex(
        (dataCardType) => dataCardType === type,
      );
      if (alreadyExists < 0) {
        return [...prevNoDataCards, type];
      }
      return prevNoDataCards;
    });
  }, []);

  const clickOnMoreDetails = useCallback(() => {
    if (isLmsWeb()) {
      navigate?.('performance', { tab: 'home' });
    } else {
      dispatch(
        renderModule({
          id: PERFORMANCE_DASHBOARD,
          props: {
            tab: 'home',
          },
        }),
      );
    }
  }, [dispatch]);

  const renderCards = () => {
    if (status === 'loading') {
      return <SkeletonLoader rect />;
    }

    if (status === 'error') {
      return <ErrorState />;
    }

    if (status === 'done' && performanceSnapshotData.length === 0) {
      return <EmptyState />;
    }

    return (
      <CardGrid classNames={styles.performanceSnapshot__cards}>
        {performanceSnapshotData.map((item, index) => {
          const cardKey = item.code || `card-${index}`;
          return (
            <PerformanceSnapshotCard
              key={cardKey}
              snapshotCard={item}
              adjustNumberOfCards={adjustNumberOfCards}
              metricsData={performanceSnapshotData}
            />
          );
        })}
      </CardGrid>
    );
  };

  return (
    <Widget
      title={locale(Keys.PERFORMANCE_SNAPSHOT)}
      content={renderCards()}
      actions={
        <Button type="outlined" onClick={clickOnMoreDetails}>
          {locale(Keys.SHOW_MORE)}
        </Button>
      }
    />
  );
}

export default PerformanceSnapshot;
